import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { SortService } from '@app/components/sorting/SortService';
import { MemberService } from '@app/services/member.service';
import { Sort } from '@angular/material/sort';
import { PdfService } from '@app/services/pdf/pdf.service';
import { DatePipe } from '@angular/common';
import { CSVDataService } from '@app/export/CSVDataService';
import { MenuItem } from 'primeng/api';
import { NavigationEnd, Router } from '@angular/router';

interface Institution {
  id: number;
  shortName: string;
  name: string;
  noOfMembers: number;
}

interface Birthday {
  id: number;
  givenName: string;
  familyName: string;
  birthday: string;
  year: number;
  celebrationDate: string;
}

@Component({
  selector: 'app-birthdaylist',
  templateUrl: './birthdaylist.component.html',
  styleUrls: ['./birthdaylist.component.css']
})
export class BirthdaylistComponent implements OnInit {
birthdayform;
  
  items: MenuItem[];
  institutionlist: Institution[] = [];
  birthdays: Birthday[] = [];

  // tslint:disable-next-line:max-line-length
  constructor(private fb: NonNullableFormBuilder, private router: Router, private institutionService: InstitutionsService, private memberService: MemberService, private pdfService: PdfService, private datePipe: DatePipe) {
    this.router.events.subscribe(x => {
      if (x instanceof NavigationEnd) {
        this.clear();
      }
    });
   }

  ngOnInit() {
    this.birthdayform = this.fb.group({
      institutionId: ['', Validators.required],
      year: ['', Validators.required]
    });

    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }, {
        label: 'Pdf',
        icon: 'fa fa-file-pdf',
        command: () => this.saveToPDF()
      }];
    this.getAllInstitutions();
  }

  getAllInstitutions() {

    this.institutionService.getInstitutions().subscribe(response => {
      this.institutionlist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });

      const removelist = ['AV1', 'AVGBREV1', 'UT1', 'EL', 'ELA', 'K', 'RLK', 'RR', 'SOFT1', 'SOFT2', 'SGL1', 'SL1'];
      this.institutionlist = this.institutionlist.filter(x => {

        return removelist.indexOf(x.shortName) === -1;
      });
    });
  }

  generateReport() {
    this.memberService.GetBirthdays(this.birthdayform.value).subscribe(response => {

      if (response) {

        response.forEach(x => {
          x.birthday = this.datePipe.transform(x.birthday, 'yyyy-MM-dd');
          x.celebrationDate = this.datePipe.transform(x.celebrationDate, 'yyyy-MM-dd');
        });

        this.birthdays = response;


      }
    });
  }

  sortData(sort: Sort) {
    const data = this.birthdays.slice();
    if (!sort.active || sort.direction === '') {
      this.birthdays = data;
      return;
    }

    this.birthdays = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id': return this.compare(a.id, b.id, isAsc);
        case 'givenname': return this.compare(a.givenName, b.givenName, isAsc);
        case 'familyname': return this.compare(a.familyName, b.familyName, isAsc);
        case 'birthday': return this.compare(a.birthday, b.birthday, isAsc);
        case 'year': return this.compare(a.year, b.year, isAsc);
        case 'celebrationdate': return this.compare(a.celebrationDate, b.celebrationDate, isAsc);
        /* case 'institutionShortName': return SortService.cmpStringsWithNumbers(a.institutionShortName, b.institutionShortName, isAsc);
         case 'institutionName': return this.compare(a.institutionName, b.institutionName, isAsc);*/
        default: return 0;
      }
    });

  }

  /*compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }*/

  clear() {
    this.birthdayform?.reset();
    this.birthdays = [];
  }



  /*  sortData() {
      const data = this.birthdays.slice();

      this.birthdays = data.sort((a, b) => {
          return this.compare(a.celebrationdate, b.celebrationdate, true);
      });
    }*/

  compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  saveToPDF() {

    const data = document.getElementById('contentToConvert');
    this.pdfService.captureScreen(data, 'p',null);
  }

  exportToCSV() {
    this.birthdays.forEach(data => {
      data.birthday = this.datePipe.transform(data.birthday, 'yyyy-MM-dd');
      data.celebrationDate = this.datePipe.transform(data.celebrationDate, 'yyyy-MM-dd');
    });
    // tslint:disable-next-line:max-line-length
    const firstrow = 'Medlemsnr;Förnamn;Efternamn;Födelsedatum;Antal år;Institutionsnamn;Institution (kortnamn);Högtidsdag';
    const datum = this.datePipe.transform(new Date(), 'yy-MM-dd');
    const filnamn = 'Födelsedagar_' + datum;

    CSVDataService.exportToCsv(filnamn + '.csv', this.birthdays, firstrow);

  }

}
